module.exports = __webpack_public_path__ + "img/kindergarten.d045bb27.jpg";